import React from 'react';
import { FormattedMessage } from 'react-intl';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {}
export default function DisenrollFailureModal({ closeAllModals }: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        closeAllModals();
    }

    return (
        <Modal id="disenrollFailureModal">
            <Modal.Header id="disenrollFailureModalHeader" titleId="indportal.plansummary.technicalissues" onHide={onClose} />
            <Modal.Body id="disenrollFailureModalBody">
                <p>
                    <FormattedMessage id="indportal.plansummary.cannotsubmitrequest" />
                </p>
                <p>
                    <FormattedMessage id="indportal.plansummary.ifyouhaveanyquestions" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="disenrollFailureModalCancelButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.cancel" 
                />
            </Modal.Controls>
        </Modal>
    );
}
